import { TYPOGRAPHY } from '@app/constants';
import { FC } from 'react';
import { ValueContainerProps } from 'react-select';
import styled from 'styled-components';

const ValueContainer: FC<ValueContainerProps> = ({
  children,
  cx,
  ...props
}) => {
  return <Root {...props}>{children}</Root>;
};

export default ValueContainer;

const Root = styled.div`
  ${TYPOGRAPHY.body1Regular14}
  align-items: center;
  display: grid;
  position: relative;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
`;
